// Centralized content to keep components clean
export const servicesList = [
  {
    id: 'classic',
    title: 'Classic Lash Extensions',
    price: 'Starting at CA$95',
    duration: '1h 30m',
    desc: 'A timeless, natural look applying one extension to one natural lash. Perfect for adding length and subtle curl.',
    bestFor: 'First-timers, natural everyday look, clients with many healthy natural lashes.',
    maintenance: 'Refills recommended every 2-3 weeks.',
    img: 'https://plus.unsplash.com/premium_photo-1661763916562-20e0314ba95f?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'hybrid',
    title: 'Hybrid Lash Extensions',
    price: 'Starting at CA$120',
    duration: '2h',
    desc: 'The perfect blend of Classic and Volume techniques. Offers a textured, wispy look that is both natural and noticeably fuller.',
    bestFor: 'Those who want a bit more drama than classic, masking sparse areas.',
    maintenance: 'Refills recommended every 2-3 weeks.',
    img: 'https://plus.unsplash.com/premium_photo-1661763898221-f8258bf76611?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'volume',
    title: 'Volume Lash Extensions',
    price: 'Starting at CA$145',
    duration: '2h 15m',
    desc: 'Multiple lightweight extensions created into a handmade fan applied to a single natural lash. Delivers a soft, fluffy, and dense appearance.',
    bestFor: 'Clients wanting a glamorous look or those with sparse natural lashes needing fullness.',
    maintenance: 'Refills recommended every 3-4 weeks.',
    img: 'https://images.unsplash.com/photo-1683719312734-e31de63957ab?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'mega',
    title: 'Mega Volume',
    price: 'Starting at CA$170',
    duration: '2h 45m',
    desc: 'The ultimate dramatic look using ultra-fine lashes to create massive, dense fans. Maximum fullness without damaging natural lashes.',
    bestFor: 'Special occasions, photoshoots, or clients who love a bold, dramatic strip-lash look.',
    maintenance: 'Refills recommended every 3-4 weeks.',
    img: 'https://images.unsplash.com/photo-1528047128849-2382ff646073?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'lift',
    title: 'Lash Lift & Tint',
    price: 'CA$85',
    duration: '1h',
    desc: 'A semi-permanent treatment that curls and darkens your natural lashes, giving the illusion of perfectly applied mascara and an eyelash curler.',
    bestFor: 'Low maintenance clients, those taking a break from extensions.',
    maintenance: 'Results last 6-8 weeks.',
    img: 'https://images.unsplash.com/photo-1589710751893-f9a6770ad71b?auto=format&fit=crop&q=80&w=800'
  }
];

export const pricingData = {
  newSets: [
    { name: 'Classic Set', price: 'CA$95' },
    { name: 'Hybrid Set', price: 'CA$120' },
    { name: 'Volume Set', price: 'CA$145' },
    { name: 'Mega Volume Set', price: 'CA$170' },
  ],
  refills: [
    { name: 'Classic Refill (2-3 wks)', price: 'CA$55' },
    { name: 'Hybrid Refill (2-3 wks)', price: 'CA$65' },
    { name: 'Volume Refill (3-4 wks)', price: 'CA$80' },
    { name: 'Mega Volume Refill (3-4 wks)', price: 'CA$95' },
  ],
  addons: [
    { name: 'Lash Lift & Tint', price: 'CA$85' },
    { name: 'Lash Removal (Our Work)', price: 'CA$25' },
    { name: 'Lash Removal (Foreign Work)', price: 'CA$40' },
    { name: 'Lash Bath', price: 'CA$15' },
  ]
};

export const faqs = [
  {
    q: "How long do lash extensions last?",
    a: "When properly applied and maintained, lash extensions can last through a full growth cycle of natural eyelashes, typically 6 to 8 weeks. However, because each lash is at a different stage in its growth cycle, we recommend getting a refill every 2 to 4 weeks to maintain a full look."
  },
  {
    q: "Can I wear makeup with extensions?",
    a: "Yes, but you must avoid oil-based products around the eyes, including oil-based mascara, eyeliner, and makeup removers, as oils break down the lash adhesive. If you choose to wear eye makeup, ensure it is extension-safe and easily removable with water-based cleansers."
  },
  {
    q: "How should I clean my lashes?",
    a: "We recommend washing your lashes daily using a specialized extension-safe foaming cleanser and a soft cleansing brush. Gently stroke in the direction of the lashes, rinse thoroughly with water, pat dry with a lint-free towel, and brush them gently with a clean spoolie."
  },
  {
    q: "Do extensions damage natural lashes?",
    a: "No, lash extensions do not damage your natural lashes when applied correctly by a certified professional. At Veloura, we prioritize the health of your natural lashes, ensuring we select the appropriate weight and length of extensions to prevent premature shedding or breakage."
  },
  {
    q: "What is your cancellation policy?",
    a: "We require at least 24 hours notice to cancel or reschedule an appointment. Cancellations made within 24 hours or no-shows will result in a forfeit of the booking deposit. This policy allows us to accommodate other clients waiting for an appointment."
  }
];

export const reviews = [
  { name: 'Isabella M.', text: 'Absolutely the best lash studio in Montreal. Sophia understood exactly what I wanted. My hybrid set looks flawless and lasted a full 3 weeks before needing a fill.', rating: 5 },
  { name: 'Chloe T.', text: 'The studio is gorgeous and so relaxing. The hygiene standards here are top-notch, which is so important to me. Obsessed with my volume lashes!', rating: 5 },
  { name: 'Amelia R.', text: 'Found my forever lash tech! The attention to detail is unmatched. My natural lashes are still super healthy even after months of wearing extensions.', rating: 5 }
];